module.exports = __webpack_public_path__ + "assets/adpoly-facility-vending-machines-bulk-upload-template.ff811b49.xlsx";